import { type MCPServerInfo } from '../../types';

const SentryServer: MCPServerInfo = {
  serverId: 'SENTRY',
  name: 'Sentry',
  slug: 'sentry',
  description:
    'Retrieve and analyze issues and errors from your Sentry.io projects. Create and retrieve projects, query issue details, trigger Seer issue fix runs and query their status. Get application debugging context quickly and improve application reliability.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.sentry.dev/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SentryServer;
